"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../../../utils/index.js"));

var _loveButton = _interopRequireDefault(require("../loveButton/loveButton.js"));

var _itemActions = require("@wix/photography-client-lib/dist/src/item/itemActions");

var _biLogger = require("@wix/photography-client-lib/dist/src/utils/biLogger");

var _lodash = _interopRequireDefault(require("lodash"));

var _consts = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/consts"));

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Social =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Social, _React$Component);

  function Social(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onDownloadKeyPress = _this.onDownloadKeyPress.bind(_assertThisInitialized(_this));
    _this.onDownloadTextKeyPress = _this.onDownloadTextKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Social.prototype;

  _proto.getSocialShare = function getSocialShare() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        id = _this$props.id,
        actions = _this$props.actions;

    if (styleParams.allowSocial) {
      var slideshowShareButton = _react["default"].createElement("i", {
        className: 'block-fullscreen progallery-svg-font-icons-share-store'
      });

      if (_index["default"].isSite()) {
        var slideshowShare = styleParams.isSlideshow ? actions.getShare() : '';
        return _react["default"].createElement("div", {
          className: 'block-fullscreen gallery-item-social-share gallery-item-social-button',
          "data-hook": "gallery-item-social-button",
          key: 'item-social-share-' + id,
          onClick: function onClick(e) {
            return actions.toggleShare(e, true);
          }
        }, slideshowShareButton, slideshowShare);
      } else {
        return _react["default"].createElement("div", {
          className: 'show-tooltip block-fullscreen gallery-item-social-share gallery-item-social-button',
          "data-hook": "gallery-item-social-button",
          key: 'item-social-share-' + id,
          onMouseOver: function onMouseOver(e) {
            return actions.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
          },
          onMouseOut: function onMouseOut() {
            return actions.itemActions.hideTooltip();
          },
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, slideshowShareButton);
      }
    }

    return '';
  };

  _proto.getLoveButton = function getLoveButton() {
    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        love = _this$props2.love;

    var props = _lodash["default"].pick(this.props, ['id', 'item', 'idx', 'currentIdx', 'styleParams', 'hashtag', 'love', 'actions']);

    return styleParams.loveButton ? _react["default"].createElement(_loveButton["default"], _extends({}, props, {
      itemId: this.props.photoId,
      layout: styleParams.isSlideshow ? 'slideshow' : 'gallery',
      showCounter: love && love.showCounter
    })) : '';
  };

  _proto.getDownload = function getDownload() {
    var _this2 = this;

    var item = _lodash["default"].pick(this.props, ['html', 'style']);

    var _this$props3 = this.props,
        styleParams = _this$props3.styleParams,
        isDemo = _this$props3.isDemo,
        type = _this$props3.type,
        download_url = _this$props3.download_url,
        actions = _this$props3.actions;

    if (styleParams.allowDownload && !_index["default"].isiOS() && !(_index["default"].isSite() && isDemo)) {
      var className = 'block-fullscreen gallery-item-social-download ' + (styleParams.allowSocial ? '' : ' pull-right ') + ' gallery-item-social-button';

      var downloadIcon = _react["default"].createElement("i", {
        className: 'block-fullscreen progallery-svg-font-icons-download' + (isDemo ? ' inactive' : '')
      });

      var genralProps = {
        className: className,
        'data-hook': 'item-download',
        'aria-label': 'Download',
        role: 'button',
        tabIndex: styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1
      };
      var downloadLink = download_url.mp4 || download_url.webm || download_url.img;
      var itemProps = {
        target: '_blank',
        href: downloadLink,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();

          _windowWrapper["default"].open(downloadLink, '_blank');

          _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, {
            origin: 'gallery'
          });
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onDownloadKeyPress(e, downloadLink);
        }
      };

      if (type === 'text') {
        return _react["default"].createElement("a", _extends({}, genralProps, {
          onClick: function onClick(e) {
            e.stopPropagation();
            actions.itemActions.downloadTextItem(item, 'gallery');
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.onDownloadTextKeyPress(e, item);
          }
        }), downloadIcon);
      } else {
        var props = isDemo ? {
          onMouseOver: function onMouseOver(e) {
            return actions.itemActions.showTooltip(e, 'Gallery_Hover_Download_FreeImages_Text');
          },
          onMouseOut: function onMouseOut() {
            return actions.itemActions.hideTooltip();
          }
        } : itemProps;
        return _react["default"].createElement("a", _extends({}, genralProps, {
          download: "download"
        }, props), downloadIcon);
      }
    }

    return '';
  };

  _proto.onDownloadKeyPress = function onDownloadKeyPress(e, downloadLink) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.stopPropagation();
        e.preventDefault();

        _windowWrapper["default"].open(downloadLink, '_blank');

        _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, {
          origin: 'gallery'
        });

        return false;
    }
  };

  _proto.onDownloadTextKeyPress = function onDownloadTextKeyPress(e, item) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.stopPropagation();
        this.props.actions.itemActions.downloadTextItem(item, 'gallery');
        return false;
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        styleParams = _this$props4.styleParams,
        id = _this$props4.id,
        showShare = _this$props4.showShare,
        isSmallItem = _this$props4.isSmallItem,
        isNarrow = _this$props4.isNarrow,
        isShort = _this$props4.isShort,
        isVerticalContainer = _this$props4.isVerticalContainer;
    var socialShare = this.getSocialShare();
    var loveButton = this.getLoveButton();
    var download = this.getDownload(); //var shopIcons = this.getShopIcons();

    var isShowArrows = styleParams.hasThumbnails;
    var isPopulated = styleParams.allowSocial || styleParams.loveButton || styleParams.allowDownload;
    var textPlacementAboveOrBelow = styleParams.titlePlacement === _consts["default"].placements.SHOW_BELOW || styleParams.titlePlacement === _consts["default"].placements.SHOW_ABOVE;
    var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows'], [isPopulated, 'populated-item'], [textPlacementAboveOrBelow, 'text-external-item']].filter(function (x) {
      return x[0];
    }).map(function (x) {
      return x[1];
    }).join(' ');
    return _react["default"].createElement("div", {
      className: 'gallery-item-social gallery-item-direction-' + styleParams.galleryTextAlign + ' ' + classes,
      key: 'item-social-' + id,
      "data-hook": "item-social"
    }, loveButton, download, socialShare);
  };

  return Social;
}(_react["default"].Component);

exports["default"] = Social;